import React, { useContext } from 'react';
import Popup from '../Popup/Popup';
import './UsagePopup.css';
import { useNavigate } from 'react-router-dom';
import { OrgContext } from '../../objects/Context';

const UsagePopup = ({ message, submessage, onClose }) => {
  const navigate = useNavigate();
  const { org } = useContext(OrgContext);
  
  const handleUpgrade = () => {
    navigate('/settings', { state: { selectedMenuItem: 'subscription' } });
  }

  const content = (
    <div className="usage-popup-content">
      <div className="message">{message}</div>
      <div className="submessage">{submessage}</div>
      <div className="usage-popup-actions">
        <button className="cancel" onClick={onClose}>Continue Usage</button>
        <button className="upgrade" onClick={handleUpgrade}>Upgrade</button>
      </div>
    </div>
  );

  return (
    <Popup content={content} onClose={onClose} />
  );
};

export default UsagePopup;
